import React from "react";
import Label from "../label";
import MessageError from "../../message/__errors";
import "../styles.css";

// Поле пароля.
export default function InputPassword({ value = '', children, placeholder, errors, className = '', hasLabel = true, autoComplete = 'current-password', ...other }) {
    if (placeholder === undefined) placeholder = children;
    return <>
        {hasLabel ? <Label>{children}</Label> : null}
        <input
            {...other}
            type="password"
            value={value ? value : ''}
            className={`input ${className}`}
            placeholder={placeholder}
            autoComplete={autoComplete}
        />
        {errors ? <MessageError errors={errors}/> : null}
    </>;
}
